// extracted by mini-css-extract-plugin
module.exports =  {"chartNoData":"chartNoData__4M3ii","rankingTableTip":"rankingTableTip__A39kJ","moveToMobileLink":"moveToMobileLink__CTfIr"};